<template>
  <div class="ats-container">
    <div class="ats-container_main">
      <section>
        <form @submit.stop.prevent="onSave">
          <fieldset class='recruiterConf'>
            <div>
              <label for="active" title="envoyer des candidats à l'ats quand ils passent en sent">envoyer</label>
              <input type="checkbox" v-model="config.active" @change="onUpdate" id="active" name="active"/>
              <modified :enable="config.active !== value.active"/>
            </div>
            <div title="Si il n y a pas de cv, utiliser le portrait du candidat en pdf.">
              <label for="portrait">CV en portrait</label>
              <input type="checkbox" v-model="config.autoportrait" @change="onUpdate" id="portrait" name="portrait"/>
              <modified :enable="config.autoportrait !== value.autoportrait"/>
            </div>
            <div v-if='isAtLeast(value, "sdk", 2, 5)' title="Toujours utiliser le portrait du candidat en pdf pour l'envoie à l'ats même si il y a un cv.">
              <label for="forceportrait">forcer en portrait</label>
              <input type="checkbox" v-model="config.forceportrait" @change="onUpdate" id="forceportrait" name="forceportrait"/>
              <modified :enable="config.forceportrait !== value.forceportrait"/>
            </div>
            <div v-if='isAtLeast(value, "sdk", 2, 6)' title="Envoyer un pdf composé du portrait et du CV">
              <label for="concatportrait">aggréger portrait et cv</label>
              <input type="checkbox" v-model="config.concatportrait" @change="onUpdate" id="concatportrait" name="concatportrait"/>
              <modified :enable="config.concatportrait !== value.concatportrait"/>
            </div>
            <div>
              <label for="autosync" title="créer des search pour les offres passant les filtres, les searchs ainsi créées seront désactiver en fonction de l'etat de publication de l'offre">search automatique</label>
              <input type="checkbox" v-model="config.autosync" @change="onUpdate" id="autosync" name="autosync"/>
              <modified :enable="config.autosync !== value.autosync"/>
            </div>
            <div v-if='isAtLeast(value, "sdk", 3, 1)'>
              <label for="ai">extraire la ville et le type de contrat du titre</label>
              <input type="checkbox" v-model="config.ai" @change="onUpdate" id="ai" name="ai"/>
              <modified :enable="config.ai !== value.ai"/>
            </div>
            <div v-if='isAtLeast(value, "sdk", 3, 2, 3)'>
              <label for="splitedLoad">charger individuelement les offres</label>
              <input type="checkbox" v-model="config.splitedLoad" @change="onUpdate" id="splitedLoad" name="splitedLoad"/>
              <modified :enable="config.splitedLoad !== value.splitedLoad"/>
            </div>
            <slot name="credential" :credential="config.credential" :meta="config.meta"></slot>
            <div>
              <label for="formId">formId</label>
              <input v-model="config.formId" @change="onUpdate" id="formId" name="formId"/>
              <modified :enable="config.formId !== value.formId"/>
            </div>
            <div>
              <label for="campaign">campagne</label>
              <input v-model="config.campaign" @change="onUpdate" id="campaign" name="campaign"/>
              <modified :enable="config.campaign !== value.campaign"/>
            </div>
            <div class="formAction">
              <input type="submit" :disabled="savingConf" class="btn" value="Sauvegarder" />
              <button @click.stop.prevent="filters()" :disabled="filterRunning" style="position: relative;">🔍️<spinner v-if="filterRunning" style="transform: scale(0.2, 0.2); position: absolute; top: -1em;"></spinner></button>
              <span class="btn" @click="openSync" :disabled="synchroRunning" style="position: relative;">synchro<spinner v-if="synchroRunning" style="transform: scale(0.2, 0.2); position: absolute; top: 2.5em"></spinner></span>
            </div>
          </fieldset>
          <fieldset class="filters">
            <legend>Filtres</legend>
            <ul>
              <li v-for="(filter, i) in config.filters" :key="filter.id">
                <offer-filter
                  :filter="filter"
                  :contracts="contractsAll"
                  :next="i < config.filters.length - 1"
                  :previous="i > 0"
                  :versions="value.versions"
                  :filterRunning="filterRunning"
                  @up="upFilter(i)"
                  @down="downFilter(i)"
                  @remove="delFilter(i)"
                  @preview="f => filters([f])"
                  ref="filters"
                />
              </li>
            </ul>
            <sweet-modal ref="filter">
              <h4>Matching jobs ({{ filtersData.length }})</h4>
              <section class="jobs">
                <ul>
                  <li v-for="job in filtersData" :key="job.id" class="job">
                    <span :class="{ synced: job.populated }"><slot name="title" :job="job"></slot></span>
                    <span v-if="job.hippolyte && job.hippolyte.search">{{ job.hippolyte.search.active ? '🟢' : '🔴' }}</span>
                    <a class="button" v-if="job.hippolyte && job.hippolyte.location" target="_blank" :href="osmLink(job)">🚩</a>
                    <slot name="open" :job="job"></slot>
                  </li>
                </ul>
              </section>
            </sweet-modal>

            <span class="btn" @click="addFilter">+</sp>
          </fieldset>
        </form>
        <sweet-modal ref="synchro">
          <h4>Etes-vous sûr de vouloir synchroniser les offres ?</h4>
          <div v-if="cancels.transfer">
            <spinner style="transform: scale(0.2, 0.2);"></spinner>
          </div>
          <button @click="synchro" :disabled="synchroRunning" v-else>Synchroniser</button>
          <button @click="closeSync">Annuler</button>
        </sweet-modal>
      <section>

      <section >
        <h4>Tranférer un candidat</h4>
        <button @click.prevent="onTransfer">Transférer</button>
        <sweet-modal ref="transfer">
          <h4>Tranférer une candidature</h4>
          <form @submit.prevent="transfer">
            <label for="conciliation">Conciliation id</label>
            <input name="conciliation" v-model="conciliation"/>
            <div v-if="cancels.transfer">
              <spinner style="transform: scale(0.2, 0.2);"></spinner>
            </div>
            <button type="submit" v-else>Transférer</button>
          </form>
        </sweet-modal>
      </section>

      <section class="jobs" style="position: relative;">
        <div>
          <h2>Offres</h2>
          <div class="checkbox-container" title="Job linké uniquement">
            <input type="checkbox" v-model="linked" :id="'linked'" />
            <label :for="'linked'"></label>
          </div>
        </div>
        <ul>
          <spinner v-if="busy" style="transform: scale(0.2, 0.2); position: absolute;"></spinner>
          <li v-for="job in jobs" :key="job.id" class="job">
            <slot name="title" :job="job"></slot>
            <span class="action">
              <template  v-if="job.hippolyte && job.hippolyte.search">
                <span v-if="job.unpublished" class="unpublished"> Dépublié </span>
                <button @click="openBoard(job)" class="edit-search-btn">
                  <edit-icon></edit-icon>
                </button>
                {{ job.hippolyte.search.title }}
                <span :title="`recherche ${job.hippolyte.search.active ? 'activée' : 'désactivée'}`">{{ job.hippolyte.search.active ? '🟢' : '🔴' }}</span>
                <button @click="unlink(job)" title="retirer">🗑️</button>
                <button v-if="search && search.id !== job.hippolyte.search.id" @click="link(job)" title="remplacer">🔗</button>
                <button @click="openMap(job)">🚩</button>
              </template>
              <template v-else-if="search">
                <button @click="link(job)" title="lier">🔗</button>
              </template>
              <slot name="open" :job="job"></slot>
            </span>
          </li>
          <li class="fake" v-for="i in new Array(10 - jobs.length)">&nbsp;</li>
        </ul>
        <slot name="paginate">
          <paginate v-model="offset" :count="count" :limit="limit"></paginate>
        </slot>
        <sweet-modal ref="map">
          <template v-if="jobEdit">
            <h4><slot name="title" :job="jobEdit"></slot><span>{{ jobEdit.hippolyte.search.active ? '🟢' : '🔴' }}</span></h4>
            <section v-if="jobEdit.hippolyte.location.lat === null || jobEdit.hippolyte.location.lng === null">Pas de coordonéees</section>
            <section v-else>
              <iframe width="425" height="350" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" :src="osmIframeLink(jobEdit)" style="border: 1px solid black"></iframe>
              <small>
                <a :href="osmLink(jobEdit)">Afficher une carte plus grande</a>
              </small>
            </section>
            <section>
              <form @submit.stop.prevent="link(jobEdit)">
                <label for="lat">latitude</label>
                <input name="lat" v-model="jobEdit.hippolyte.location.lat"/>
                <label for="lng">longitude</label>
                <input name="lng" v-model="jobEdit.hippolyte.location.lng"/>
                <button type="submit">Changer</button>
              </form>
            </section>
          </template>
        </sweet-modal>
      </section>
    </div>
  </div>
</template>
<script>
import Recruiter from '/user/recruiter/recruiter.entity'
import Search from '/requirement/entity'
import Trade from '/trade/entity'
import Spinner from '/layout/spinner'
import cancel from '/cancel.mixin.js'
import Paginate from '/layout/paginate'
import { SweetModal } from 'sweet-modal-vue'
import { Treeselect } from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import Contract from '../requirement/contract.entity'
import { sanitize } from 'dompurify'
import { VueEditor } from 'vue2-editor/dist/vue2-editor.umd.min'
import { isAtLeast } from '../fun'
import EditIcon from '/icons/edit'
import OfferFilter from '/ats/filter'
import Modified from '/ats/modified'

export default {
  name: 'hippolyte.services.ats.config',
  components: {
    VueEditor, Treeselect, Paginate, Spinner, SweetModal, EditIcon, OfferFilter, Modified
  },
  mixins: [cancel],
  props: {
    value: Object,
    credential: Object,
    service: String,
    recruiter: Recruiter,
    search: Search,
    savingConf: Boolean
  },
  watch: {
    offset: 'load',
    linked: function () {
      this.offset = 0
      this.load()
    },
    savingConf: function (next) {
      if (!next) {
        this.load()
      }
    },
    jobs: function() {
      this.$emit('update')
    },
    value: {
      handler () {
        this.config = this.capture()
      },
      deep: true
    }
  },
  data () {
    return {
      contractsAll: [],
      config: this.capture(),
      jobs: [],
      limit: 10,
      offset: 0,
      count: 0,
      busy: false,
      selected: null,
      conciliation: null,
      synchroRunning: false,
      filterRunning: false,
      filtersData: [],
      jobEdit: null,
      linked: false
    }
  },
  mounted () {
    this.getContracts()
    this.load()
    this.$socket.sub(`/ats/${this.service}/recruiter/${this.recruiter.id}`, 'SCAN_DONE', ({ body }) => {
      this.$toast(`désactivé: ${body.data.unactivated.length}, activé: ${body.data.activated.length}, créé: ${body.data.created.length}`, { theme: 'success' })
      this.load()
      this.synchroRunning = false
    })
  },
  destroyed () {
    this.$socket.unsub(`/ats/${this.service}/recruiter/${this.recruiter.id}`, 'SCAN_DONE')
  },
  methods: {
    capture () {
      return Object.assign({
        active: false,
        credential: JSON.parse(JSON.stringify(this.credential)),
        formId: null,
        campaign: null,
        autosync: false,
        ai: false,
        splitedLoad: false,
        autoportrait: false,
        forceportrait: false,
        concatportrait: false,
        filters: [],
        meta: ''
      }, JSON.parse(JSON.stringify(this.value)))
    },
    openBoard (job) {
      try {
        window.open([
          document.location.protocol, '',
          document.location.host.replace('conciliator', 'conciliateur'),
          'recruiter',
          this.recruiter.id,
          'search',
          job.hippolyte.search.id,
          'edit'
        ].join('/'))
      } catch (err) {
        console.log(err)
      }
    },
    async getContracts () {
      this.contractsAll = await Contract.search(this.$socket)
        .then(r => r.map(c => {
          return {
            id: c.id,
            label: c.name
          }
        }))
    },
    addFilter () {
      this.config.filters.push({
        id: Math.random().toString(36).substr(2, 5)
      })
    },
    delFilter (at) {
      this.config.filters.splice(at, 1)
    },
    upFilter (at) {
      const [item] = this.config.filters.splice(at, 1)
      this.config.filters.splice(at - 1, 0, item)
    },
    downFilter (at) {
      const [item] = this.config.filters.splice(at, 1)
      this.config.filters.splice(at + 1, 0, item)
    },
    select (job) {
      this.selected = this.selected === job ? null : job
    },
    openSync () {
      this.$refs.synchro.open()
    },
    closeSync () {
      this.$refs.synchro.close()
    },
    async synchro () {
      this.synchroRunning = true
      try {
        const data = await this.$socket.service(`${this.service}.jobs/SYNC`, {
          recruiter: this.recruiter.id
        })
        await this.load()
      } catch {
        this.$toast('la syncro a échoué', { theme: 'error' })
      }
      this.closeSync()
      this.$refs.filter.close()
    },
    async filters (filters) {
      this.filterRunning = true
      if (!filters) {
        filters = this.$refs.filters.map(f => f.capture())
      }
      try {
        const data = await this.$socket.service(`${this.service}.jobs/FILTER`, {
          recruiter: this.recruiter.id,
          filters
        })
        this.filtersData.splice(0, this.filtersData.length, ...data)
        this.$refs.filter.open()
      } catch {
        this.$toast('le filtre a échoué', { theme: 'error' })
      }
      this.filterRunning = false
    },
    onUpdate () {
      for(const key in this.config.credential) {
        if(typeof this.config.credential[key] === 'string') {
          this.config.credential[key] = this.config.credential[key].trim()
        }
      }
    },
    onSave () {
      if (this.config.filters.length) {
        this.config.filters.splice(0, this.config.filters.length, ...this.$refs.filters.map(f => f.capture()))
      }
      this.onUpdate()
      this.$emit('input', this.config)
    },
    async load () {
      this.cancel('jobs')
      this.busy = true
      this.selected = null
      try {
        const data = await this.$socket.service(`${this.service}.jobs/LIST`, {
          linked: this.linked,
          recruiter: this.recruiter.id,
          limit: this.limit,
          offset: this.offset
        }, { cancel: this.token('jobs') })
        this.jobs.splice(0, this.limit, ...data.docs)
        this.count = data.count
        this.cancel('jobs', null)
        this.busy = false
      } catch (err) {
        try {
          this.handleCancel(err)
        } catch {
          this.busy = false
        }
      }
    },
    async link (job) {
      try {
        const data = await this.$socket.service(`${this.service}.jobs/LINK`, {
          search: job.hippolyte?.search.id || this.search.id,
          job: job.id,
          location: job.hippolyte?.location
        })
        Object.assign(job, data)
        this.$toast(`${job.title} lié à ${job.hippolyte.search.title}`, { theme: 'success' })
        this.$forceUpdate()
      } catch (err) {
        if (err.response && err.response.status === 409) {
          return this.$toast(`Une autre recherche est déjà lié à cet offre`, { theme: 'error' })
        }
        this.$toast(`${job.title} n'a pas pu être lié à ${this.search.title || this.search.id}`, { theme: 'error' })
      }
    },
    async unlink (job) {
      try {
        const title = job.hippolyte.search.title
        await this.$socket.service(`${this.service}.jobs/LINK`, {
          job: job.id || job.reference,
          recruiter: this.recruiter.id
        })
        Object.assign(job, { hippolyte: { search: null } })
        this.$toast(`${title} n'as plus d'offre`, { theme: 'success' })
        const f = this.jobs.find(j => j.id === job.id)
        if (f) {
          f.hippolyte = undefined
          this.$forceUpdate()
        }
      } catch {
        this.$toast(`${title} n'a pas pu être délié`, { theme: 'error' })
      }
    },
    onTransfer () {
      this.$refs.transfer.open()
    },
    async transfer () {
      this.cancel('transfer')
      try {
        const data = await this.$socket.service(`${this.service}.jobs/SEND`, {
          conciliation: this.conciliation
        }, { cancel: this.token('transfer') })
        this.$toast(`${this.candidate} transféré`, { theme: 'success' })
        this.cancel('transfer', null)
        this.$refs.transfer.close()
      } catch (err) {
        this.$toast(`${this.conciliation} n'a pas pu être transféré`, { theme: 'error' })
        this.cancel('transfer', null)
        this.handleCancel(err).catch()
      }
    },
    osmLink (job) {
      const params = `mlat=${job.hippolyte.location.lat}&mlon=${job.hippolyte.location.lng}`
      const hash = [
        'map=7',
        job.hippolyte.location.lat,
        job.hippolyte.location.lng
      ].join('/')
      return `https://openstreetmap.org/?${params}#${hash}`
    },
    osmIframeLink (job) {
      const { lat, lng } = job.hippolyte.location
      const bbox = [
        lng - 2,
        lat - 2,
        lng + 2,
        lat + 2
      ].join('%2C')
      const params = `bbox=${bbox}&marker=${lat}%2C${lng}`
      return `https://openstreetmap.org/export/embed.html?${params}`
    },
    openMap (job) {
      this.jobEdit = job
      if (!job.hippolyte.location) {
        job.hippolyte.location = { lat: null, lng: null }
      }
      this.$refs.map.open()
    },
    isAtLeast (lib, ...args) {
      return isAtLeast(this.value.versions, ...args)
    }
  }
}
</script>

<style lang="stylus" scoped>
@require '~/colors.styl'
input[type="checkbox"]
  height auto
form
  margin 1em
  display flex
  flex-wrap wrap
  fieldset
    width calc(45% - 2em)
    border 1px #eee solid
    &.recruiterConf
      position sticky
      top 2em
      height fit-content
    &.filters
      ul
        padding-left 1em
        li
          background white
          margin 1em 0
          padding 1em 0.5em
          list-style-type none
          section:first-child
            justify-content start
          details
            section div
              display flex
              div
                display inline
                label
                  text-align left
                  display block
            &>.description
              justify-content center
              .quillWrapper
                min-width 600px
                .ql-container
                  font-family 'Montserrat'
            &>.tradeSelect
              justify-content center
            section, .action
              display flex
              justify-content end
              .btn
                display flex
                align-items center
                background-color $color-torrent
  .formAction
    display flex
    background-color transparent
  textarea
    background #eee
    border-radius 0 4px 4px 0
    font-size 1em
    line-height 1.5em
    border 1px #eee solid
    width 80%
    height 100px
    &:focus
      border 1px #ccc solid
  div
    display grid
    grid-template-columns 150px 1fr
    background white
    margin 0.4em 0
    padding 3px 3px 3px 0.8em
    border-radius 4px
    align-items center
    label
      grid-column 1
      margin-right 1em
      text-align right
      margin-top auto
      margin-bottom auto
    input, select
      grid-column 2 / 3
      background #eee
      border-radius 0 4px 4px 0
      font-size 1em
      line-height 1.5em
      border 1px #eee solid
      &:focus
        border 1px #ccc solid
    button
      grid-column 3
    small
      color red
      grid-column 2
    .modified
      grid-column 3
button, .btn
  background white
  border none
  color black
  border-radius 2em
  line-height 1em
  margin 0.2em 0
  padding 0.4em 1.5em
  font-size 0.9em
  cursor pointer
  text-decoration none
  &::first-letter
    text-transform capitalize
  &:focus, &:hover
    outline none
  &.invert
    color white
    border 1px white solid
  :disabled
    background-color cadetblue
    &:hover
      transform: scale(1.05)
  #floatingBarsG-container
    width auto
.ats-container
  width 100%
  .ats-container_main
    width 100%
    .checkbox-container
        display flex
        padding-left 1em
        switch($color-green, white)
        align-items center
    section.jobs
      div
        display flex
        align-content end
      ul
        padding 1em
        list-style none
        .synced
          text-decoration-line line-through
        li.job
          background white
          margin 0.5em 0
          width auto
          padding 0.4em 0.8em
          border-radius 1em
          cursor pointer
          display flex
          justify-content space-between
          .action
            button, .button
              background $color-torrent
              padding 0.2em 0.4em
              margin 0.1em
              border-radius 50%
            &.fake
              background #e8e8e8
            .unpublished
              color red
          .edit-search-btn svg
            height 1em
            &:hover
              fill white

</style>
